import { useCollectionData } from 'react-firebase-hooks/firestore';
import { getTeamChatMessagesRefQuery } from '../../../firebase/applications/app-team-chat';

const useTeamChatMessages = (appId) => {
  const [ messagesData, messagesLoading, messagesError ] = useCollectionData(getTeamChatMessagesRefQuery(appId), {snapshotOptions: {serverTimestamps:'estimate'}})
  return [ messagesData || [], messagesLoading, messagesError ]
};

export default useTeamChatMessages;